import {SUPPORT_EVENTS} from '../consts';
import {SupportEvents} from '../types';

const supportEvents = new Set<string>(Object.keys(SUPPORT_EVENTS));

export function supportEvent(eventName: string): eventName is SupportEvents {
  return supportEvents.has(eventName);
}
